import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Button, withStyles } from '@material-ui/core';
import CustomScrollbars from '../../util/CustomScrollbars';
import { FeatureFlagsContext } from '~/contexts/FeatureFlagsContext';
import styles from './sidenavStyles';
import {
  getInitialOpenMenus,
  getNewOpenMenus,
  shouldHideLink,
  canShowFeatureForId,
} from '../SideNav/utils/index';
import { menuItems } from '../SideNav/menuItems';

class SidenavContent extends Component {
  static contextType = FeatureFlagsContext;

  state = {
    openMenus: {
      home: false,
      employees: false,
      juridicalPerson: false,
      contracts: false,
      contract: false,
      contractEdit: false,
      boleto: false,
      sales: false,
      health: false,
    },
  };

  componentDidMount() {
    this.setInitialOpenMenus();
  }

  setInitialOpenMenus = () => {
    const { location } = this.props;
    const { pathname } = location;
    const initialOpenMenus = getInitialOpenMenus(pathname);
    this.setState({ openMenus: initialOpenMenus });
  };

  handleMenuClick = (menuId, path) => {
    const redirectMenuIds = [
      'home',
      'contract',
      'contractEdit',
      'boleto',
      'sales',
      'health',
    ];

    const isRedirectMenu = redirectMenuIds.includes(menuId);

    if (isRedirectMenu) {
      this.props.history.push(path);
      this.props.handleDrawerClose();
    }

    this.toggleMenu(menuId, isRedirectMenu);
  };

  toggleMenu = (menuId, isRedirectMenu) => {
    this.setState((prevState) => {
      const newOpenMenus = getNewOpenMenus(prevState.openMenus, menuId);
      if (!prevState.openMenus[menuId] && !isRedirectMenu) {
        this.props.handleDrawerOpen();
      }
      return { openMenus: newOpenMenus };
    });
  };

  hiddenLink = (roles) => {
    const usertype = localStorage.getItem('usertype');
    return shouldHideLink(roles, usertype);
  };

  isActive = path => this.props.location.pathname === path;

  renderIcon = (IconComponent, path) => {
    const { classes } = this.props;
    return (
      <IconComponent
        className={`${classes.icon} ${classes.iconInactive}`}
      />
    );
  };

  canShowFeature(featureFlags, id) {
    return canShowFeatureForId(featureFlags, id);
  }

  render() {
    const { classes, open } = this.props;
    const { openMenus } = this.state;
    const { featureFlags } = this.context;

    return (
      <CustomScrollbars className={classes.scrollbar}>
        <ul className={classes.navMenu}>
          {menuItems.map(({ id, to, icon, text, roles }) =>
            !this.hiddenLink(roles) &&
            this.canShowFeature(featureFlags, id) &&
            this.canShowFeature() && (
              <li
                key={id}
                id={id}
                className={`menu ${openMenus[id] ? 'open' : ''} ${
                  !open ? 'icon-only' : ''
                }`}
              >
                <Button
                  onClick={() => this.handleMenuClick(id, to)}
                  className={openMenus[id] ? 'open' : ''}
                >
                  {this.renderIcon(icon, to)}
                  {open && <span className={classes.navText}>{text}</span>}
                </Button>
                {id === 'employees' && openMenus[id] && (
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        to="/app/funcionarios"
                        onClick={this.props.handleDrawerClose}
                      >
                        <span className={classes.navSubText}>
                          Funcionários
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/app/cadastrar-desligar"
                        onClick={this.props.handleDrawerClose}
                      >
                        <span className={classes.navSubText}>
                          Cadastrar / Desligar
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/app/mensalidades"
                        onClick={this.props.handleDrawerClose}
                      >
                        <span className={classes.navSubText}>
                          Mensalidades
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                )}
                {id === 'juridicalPerson' && openMenus[id] && (
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        to="/app/pessoa-juridica/consulta-pj"
                        onClick={this.props.handleDrawerClose}
                      >
                        <span className={classes.navSubText}>
                          Consulta PJ
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                )}
                {id === 'contracts' && openMenus[id] && (
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        to="/app/contratos/consulta-contrato"
                        onClick={this.props.handleDrawerClose}
                      >
                        <span className={classes.navSubText}>
                          Consulta Contrato
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )
          )}
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(withStyles(styles)(SidenavContent));
